import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Image, Dropdown } from "react-bootstrap";
import logo from "../../../assets/images/logo.svg";
import avatar from "../../../assets/images/avatar.png";
import Spinner from "react-bootstrap/Spinner";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import { useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

const HeaderNew = (props) => {
	const customerName = props.customerName;
	const [amount, setAmount] = useState([]);
	const [showEstimate, setShowEstimate] = useState(false);
	const [container, setContainer] = useState(false);
	const renewalData = useSelector((state) => state.RenewalData);
	const loading = useSelector((state) => state.LoadingMonthly);
	const [header, setHeader] = useState(false);
	let history = useHistory();

	function getMeta(metaName) {
		const metas = document.getElementsByTagName("meta");

		for (let i = 0; i < metas.length; i++) {
			if (metas[i].getAttribute("name") === metaName) {
				return metas[i].getAttribute("content");
			}
		}

		return "";
	}

	useEffect(() => {
		if (isMobile) {
			if (typeof window !== "undefined") {
				window.addEventListener("scroll", () =>
					setHeader(window.pageYOffset > 98)
				);
			}
		}
	}, []);

	useEffect(() => {
		if (renewalData) {
			setAmount(renewalData.amount);
		}
	}, [renewalData]);

	useEffect(() => {
		return history.listen((location) => {
			let path = location.pathname.split("/");
			if (
				(path[5] && path[5] !== "complete" && path[5] !== "renewal") ||
				path[3] === "build"
			) {
				setShowEstimate(true);
			} else {
				setShowEstimate(false);
			}
		});
	}, [history]);

	useEffect(() => {
		return history.listen((location) => {
			let path = location.pathname.split("/");
			if (path[5] && path[5] === "renewal") {
				setContainer(true);
			} else {
				setContainer(false);
			}
		});
	}, [history]);

	const onLogout = () => {
		const headers = new Headers({
			"X-CSRF-Token": getMeta("csrf-token"),
			"X-Requested-With": XMLHttpRequest,
			Accept: "application/json",
		});
		const requestOptions = {
			method: "DELETE",
			headers,
		};
		fetch(`/users/sign_out`, requestOptions).then(() =>
			window.location.reload()
		);
	};

	return (
		<div className="img">
			<div
				className={` header justify-content-center mx-auto ${
					container ? "otcontainer2" : "otcontainer1"
				} 
				 ${showEstimate ? "d-md-flex" : "d-flex ml-4"}`}
			>
				<div className="col d-flex justify-content-start mt-md-5 mb-5">
					<Image src={logo} className="mt-5 mt-md-0 openlogo" />
				</div>
				<div
					className={`col justify-content-center  pl-0 pr-0 ${
						showEstimate ? "d-flex" : "d-none"
					} ${header ? "fixed-top mt-md-0" : "mt-md-5"}`}
				>
					<div
						className={`col-12 col-md-9 d-flex estimate justify-content-center ${
							header ? "position-sticky" : ""
						}`}
					>
						<div className="align-items-center d-flex mt-3">
							{loading ? (
								<Spinner animation="border" variant="light" />
							) : (
								<>
									<p className="monthly ">Monthly Estimate: </p>
									<p className="ml-2 monthly-total">
										{formatter.format(
											_.get(amount, `annual_with_discount_monthly_estimate`, "")
										)}
									</p>
								</>
							)}
						</div>
					</div>
				</div>
				<div
					className={`col justify-content-end ${
						showEstimate ? "d-none" : "d-flex"
					}`}
				>
					<div className="customer-header__user d-md-block mt-3">
						<div className="dropdown">
							<a className="dropdown__btn">
								<Image src={avatar} className="avatar" />
							</a>

							<ul className="dropdown__content">
								<li>
									<h1 className="t1">{customerName}</h1>
									<span className="t2">Member Since </span>
								</li>
								<li>
									<a href="/users/edit?v3=true" className="t3">
										Settings &amp; Password
									</a>
								</li>
								<li>
									<a onClick={onLogout} className="t3">
										Sign Out
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeaderNew;
